import React, { Fragment, useState } from 'react';
import {
    AppBar,
    IconButton,
    styled,
    Toolbar,
    Tooltip,
    Link,
} from '@mui/material';
import Icon from '@mdi/react';
import { mdiHelpCircle, mdiMagnify } from '@mdi/js';
import TrimbleAppLauncher from '@tcx/trimble-app-launcher/lib/AppLauncher';

import { useAppSelector } from '../../state/hooks';
import { hasNetworkInsightsRole } from '../../utils/environmentUtils';
import Hidden from '../layout/hidden';
import UserMenu from '../Menus/UserMenu';
import NavMenu from '../Menus/NavMenu';
import LaneSearch from './LaneSearch';
import { ReactComponent as NetworkInsightsLogo } from '../../assets/images/Network_Insights_Logo_Inverted.svg';
import { ReactComponent as NetworkInsightsMobileLogo } from '../../assets/images/Network_Insights_Logo_Inverted_Mobile.svg';

const classesPrefix = 'appHeader';

const classes = {
    logoContainer: `${classesPrefix}-logoContainer`,
    appLogo: `${classesPrefix}-appLogo`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => {
    return {
        [`& .${classes.logoContainer}`]: {
            display: 'flex',
            flexGrow: 1,
        },
        [`& .${classes.appLogo}`]: {
            maxWidth: '200px',
            maxHeight: '40px',
            [theme.breakpoints.down('sm')]: {
                width: '48px',
            },
        },
    };
});

const AppHeader = (): React.JSX.Element => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const userLoginStatus = useAppSelector((state) => { return state.user.userLoginStatus; });
    const userDetails = useAppSelector((state) => { return state.user.userDetails; });

    const hasAppPermission = hasNetworkInsightsRole({ userLoginStatus, userDetails });

    return (
        <Fragment>
            <StyledAppBar position='sticky'>
                <Toolbar>
                    <NavMenu />
                    <div className={classes.logoContainer}>
                        <Hidden direction='up' breakpoint='sm'>
                            <NetworkInsightsMobileLogo className={classes.appLogo} />
                        </Hidden>
                        <Hidden direction='only' breakpoint='xs'>
                            <NetworkInsightsLogo className={classes.appLogo} />
                        </Hidden>
                    </div>
                    {
                        hasAppPermission &&
                        <Tooltip title='Lane Search'>
                            <span>
                                <IconButton
                                    color='inherit'
                                    size='large'
                                    onClick={(): void => { return setIsSearchOpen(!isSearchOpen); }}
                                >
                                    <Icon path={mdiMagnify} size={1} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    }

                    <Tooltip title='Network Insights Help'>
                        <IconButton
                            color='inherit'
                            size='large'
                            component={Link}
                            underline='none'
                            target='_blank'
                            rel='noopener noreferrer'
                            href='https://learn.transportation.trimble.com/discover/result/?sub=LC/optimization/networkinsights/onlinehelp/&fn=/index.html&tl=Network-Insights-Online-Help-Table-of-Contents'
                        >
                            <Icon path={mdiHelpCircle} size={1} />
                        </IconButton>
                    </Tooltip>
                    <TrimbleAppLauncher />
                    <UserMenu />
                </Toolbar>
            </StyledAppBar>
            <LaneSearch
                open={isSearchOpen}
                onClose={(): void => { setIsSearchOpen(false); }}
            />
        </Fragment>
    );
};

export default AppHeader;
